<form class="w-12"
      #form="ngForm"
      novalidate="true"
      method="POST">
    @if(display){
    <div [grid]="12"
         [gridColumnGap]="isSM ? '0px' : '38px'"
         [ngClass]="{'wrap-s wrap-m' : isSelection}"
         class="wrap-x wrap-l p-b-20 m-b-5">
        <div [gridColumn]="isSM ? 12 : 8"
             class="p-t-14 p-t-7-s p-t-7-m">
            <h2 class="hero h1-s h1-m col-1 m-b-7-s m-b-7-m"
                [ngClass]="isSelection ? 'm-b-14' : 'm-b-10 wrap-s wrap-m'"
                *iCms="'title' of component; skipEmpty: true"></h2>
            @if(isSelection){

            @if(listing?.getFiltersWithMatches()?.length){
            <div [grid]="2"
                 class="m-b-13-s m-b-13-m m-b-10"
                 [gridColumnGap]="'40px'"
                 [gridRowGap]="'24px'">
                @for (filter of listing?.getFiltersWithMatches(); track filter.id) {
                @switch (filter.filterType) {
                @case ('attribute-option') {
                <samples-filter [gridColumn]="isSM ? 2 : 1"
                                [filter]="filter"></samples-filter>
                }
                }
                }
            </div>
            }

            @if(groups?.length){
            <div [grid]="2"
                 [gridColumnGap]="'40px'"
                 [gridRowGap]="'40px'">
                @for(group of groups; track group.fabricStyle) {
                <div class="bg-col-52 b-a b-col-51"
                     [gridColumn]="isSM ? 2 : 1"
                     style="border-radius: 8px; box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.08) inset;">
                    <div class="p-t-3 p-b-3 p-l-2 p-r-2 b-b b-col-5">
                        <h4 class="h4 s1-s s1-m col-1">{{group.title}}</h4>
                    </div>
                    <div [grid]="4"
                         style="height: auto; overflow: auto"
                         class="custom-scrollbar p-a-2 _samples-container"
                         [gridColumnGap]="isSM ? '8px' : '10px'"
                         [gridRowGap]="'8px'">
                        @for(product of group.products; track product.id) {
                        <button type="button"
                                (click)="addProduct(product)"
                                [ngClass]="{'pe-none' : isFull || isSelected(product.id)}"
                                class="flex w-12"
                                [gridColumn]="1">
                            <span class="flex-column w-12">
                                <span style="border-radius: 12px;"
                                      class="overflow-hidden pos-relative block">
                                    <span class="fill b-a"
                                          style="border-radius: 12px;"
                                          [ngClass]="isSelected(product.id) ? 'b-col-6 b-w-2' : 'b-col-5'">

                                    </span>
                                    <img class="w-12"
                                         [dfImage]="product.data?.image"
                                         [alt]="product.data?.name || ''"
                                         [ratio]="1">
                                    @if(isSelected(product.id)){
                                    <span class="fill flex flex-justify-center flex-middle">
                                        <span class="flex flex-justify-center flex-middle bg-col-w _tick-container"
                                              style="border-radius: 100%;">
                                            <i class="_tick"></i>
                                        </span>
                                    </span>
                                    }
                                </span>
                                <span class="m-t-1 w-12 center p2 c2-s c2-m">
                                    {{product.data?.name}}
                                </span>
                            </span>
                        </button>
                        }
                    </div>
                </div>
                }
            </div>
            }
            }

            @if(isForm){
            @if (model?.data) {


            <div class="w-12 bg-col-52 b-a b-col-51 p-t-10 p-b-10 p-l-5 p-r-5 p-t-5-s p-b-5-s p-t-5-m p-b-5-m p-l-4-s p-l-4-m p-r-4-s p-r-4-m"
                 [grid]="12"
                 style="border-radius: 12px;"
                 [gridColumnGap]="isSM ? '16px' : '20px'"
                 [gridRowGap]="isSM ? '16px' : '20px'">
                @if (component?.formTitle){
                <p class="p1 col-1"
                   [gridColumn]="12"
                   *iCms="'formTitle' of component; skipEmpty: true"></p>
                }
                @for (field of fields; track field; let first = $first) {
                @if(!field.is_hidden_field){
                @if(field.field_type === 'address') {
                <customform-address-fieldset [form]="form"
                                             [customFormField]="field"
                                             [gridColumn]="getFieldGridColumn(field)"
                                             [data]="data[field.cid]"></customform-address-fieldset>

                } @else if(isSupportedField(field.field_type)) {
                <div [gridColumn]="getFieldGridColumn(field)">
                    @if(field.field_type === 'file_upload'){
                    <div class="bg-col-52 p-a center"
                         style="border-radius: 12px;">
                        <span class="s1 inline-block m-b">{{field.label | translate}}</span>
                        <file-input class="block"
                                    [maxSize]="getMaxSize(field)"
                                    [accept]="field.image_type"
                                    (fileChange)="onUpload($event, field)"
                                    [inputId]="'samples-input-field' + field.cid"> <label [buttonStyle]="'button-1'"
                                   [attr.for]="'samples-input-field' + field.cid"
                                   class="cursor-pointer">{{'select files' |
                                translate }} </label>
                        </file-input>

                    </div>
                    <div class="m-t">
                        <result [status]="getFileInputStatus(field)"
                                class="m-b-2 _result"></result>
                        <form-mui-field class="block m-b-2"
                                        [errorMessage]="'Please upload image' | translate">
                            <input type="hidden"
                                   [name]="field.cid"
                                   [(ngModel)]="data[field.cid]"
                                   required>
                        </form-mui-field>
                        @if(data[field.cid]?.name){
                        <div class="flex flex-middle m-b-2">
                            <span class="p2 col-3">{{data[field.cid].name}}</span>
                            <button inlineButton
                                    class="m-l-2"
                                    (click)="resetFile(field)"><span class="s2"
                                      style="letter-spacing: 0;">{{'Remove' | translate}}</span></button>
                        </div>
                        }
                        @if(field.field_options?.description) {
                        <p class="p2">{{field.field_options?.description |
                            translate}}
                        </p>
                        }
                    </div>
                    } @else if(field.field_type === 'checkboxes'){
                    @if(field.label){
                    <p class="p2 m-b-2"
                       [ngClass]="{'_required-label' : field.required}">{{field.label | translate}}</p>
                    }
                    <!-- input: checkbox -->
                    @for (option of field.field_options?.options; track option; let i = $index) {
                    <checkbox>
                        <span class="flex flex-middle">
                            <input type="checkbox"
                                   [(ngModel)]="localCheckboxesData[field.cid][option.label]"
                                   (ngModelChange)="localOnCheckboxesChange(field)"
                                   [name]="field.cid + i">
                            {{option.label | translate}}
                        </span>
                    </checkbox>
                    }

                    @if(field.field_options?.include_other_option){
                    <div class="flex flex-top m-t-2">
                        <checkbox style="padding-top: 11px;">
                            <input type="checkbox"
                                   [(ngModel)]="localCheckboxesData[field.cid][checkboxesOtherOptionLabel]"
                                   (ngModelChange)="localOnCheckboxesChange(field)"
                                   [name]="field.cid + '_other'">
                        </checkbox>
                        <form-mui-field [label]="('Other' | translate)"
                                        class="_checkboxes-other-field"
                                        [errors]="{required: ('The Other field should not be empty' | translate)}">
                            <input type="text"
                                   [name]="field.cid + '_other_text'"
                                   [required]="!!localCheckboxesData[field.cid][checkboxesOtherOptionLabel]"
                                   [(ngModel)]="checkboxesFieldsOtherData[field.cid]">
                        </form-mui-field>
                    </div>
                    }

                    <form-field class="block">
                        @if(field.required){
                        <input type="hidden"
                               [name]="field.cid"
                               [(ngModel)]="checkboxes[field.cid]"
                               required>
                        }
                    </form-field>
                    } @else if(field.field_type === 'subscription'){
                    <!-- input: subscription checkbox -->
                    @if(field.label){
                    <p class="p2 m-b-2"
                       [ngClass]="{'_required-label' : field.required}">{{field.label | translate}}</p>
                    }
                    <form-field>
                        <checkbox [alignCenter]="true">
                            <input type="checkbox"
                                   [name]="field.cid"
                                   [required]="!!field.required"
                                   [(ngModel)]="data[field.cid]">{{field.field_options?.options?.[0]?.label |
                            translate}}
                        </checkbox>
                    </form-field>
                    } @else if(field.field_type === 'radio'){
                    @if(field.label){
                    <p class="p2 m-b-2"
                       [ngClass]="{'_required-label' : field.required}">{{field.label | translate}}</p>
                    }
                    <form-field class="block">
                        <!-- input: radio -->
                        <radio-group class="flex-column"
                                     [name]="field.cid"
                                     [required]="!!field.required"
                                     [(model)]="data[field.cid]">
                            @for (option of field.field_options?.options; track option; let i = $index) {
                            <radio-group-item class="w-12 m-t-2"
                                              [value]="option.label">
                                <span [innerHtml]="option.label | translate"></span>
                            </radio-group-item>
                            }
                        </radio-group>
                    </form-field>
                    } @else if(field.field_type === 'dropdown'){

                    <form-mui-field class="block"
                                    [label]="field.label | translate">
                        <!-- input: select -->
                        <select [name]="field.cid"
                                [required]="!!field.required"
                                [(ngModel)]="data[field.cid]">
                            @if (field.field_options?.include_blank_option) {
                            <option value=""
                                    disabled
                                    selected>{{(field.placeholder | translate) || ( 'Select %' | translate: field.label
                                )}}
                            </option>
                            }
                            @for (option of field.field_options?.options; track option) {
                            <option [value]="option.value || option.label">{{option.label | translate}}</option>
                            }
                        </select>
                    </form-mui-field>
                    @if(isOtherForDropdownSelected(field)){
                    <form-mui-field class="block m-t"
                                    [errors]="{required: ('The Other field should not be empty' | translate)}"
                                    [label]="('Enter your answer' | translate)">

                        <input type="text"
                               [name]="field.cid + '_other'"
                               [required]="true"
                               [(ngModel)]="dropdownFieldsOtherData[field.cid]">
                    </form-mui-field>
                    }
                    } @else {

                    <form-mui-field class="block"
                                    [label]="field.field_type === 'subscription' ? undefined :  (field.label | translate)">
                        @switch (field.field_type) {


                        <!-- input: text -->
                        @case ('text') {
                        <input type="text"
                               [name]="field.cid"
                               [required]="!!field.required"
                               [(ngModel)]="data[field.cid]"
                               [placeholder]="(field.placeholder | translate )|| ''">
                        }
                        @case ('phone') {
                        <input type="text"
                               [name]="field.cid"
                               [required]="!!field.required"
                               [(ngModel)]="data[field.cid]"
                               [placeholder]="(field.placeholder | translate )|| ''">
                        }
                        <!-- input: number -->
                        @case ('number') {
                        <input type="number"
                               [name]="field.cid"
                               [required]="!!field.required"
                               [(ngModel)]="data[field.cid]"
                               [placeholder]="(field.placeholder | translate) || ''">
                        }
                        <!-- input: email -->
                        @case ('email') {
                        <input type="email"
                               validatePattern="email"
                               [name]="field.cid"
                               [required]="!!field.required"
                               [(ngModel)]="data[field.cid]"
                               [placeholder]="(field.placeholder | translate) || ''">
                        }
                        <!-- input: textarea -->
                        @case ('paragraph') {
                        <div>
                            <textarea [name]="field.cid"
                                      [required]="!!field.required"
                                      [(ngModel)]="data[field.cid]"
                                      (keydown)="detectChanges()"
                                      (keyup)="detectChanges()"
                                      [maxlength]="field.field_options?.maxlength || null"
                                      [minlength]="field.field_options?.minlength || null"
                                      [placeholder]="(field.placeholder | translate) || ''"></textarea>
                            @if(field.field_options?.maxlength){
                            <div class="flex flex-justify-between m-t-1 p-l c1 col-11">
                                <span>{{'Characters' | translate}}</span>
                                <span>{{data[field.cid]?.length || 0}}/{{field.field_options?.maxlength}}</span>
                            </div>
                            }
                        </div>
                        }
                        <!-- input: select -->
                        @case ('dropdown') {
                        <select [name]="field.cid"
                                [required]="!!field.required"
                                [(ngModel)]="data[field.cid]">
                            @if (field.field_options?.include_blank_option) {
                            <option value=""
                                    disabled
                                    selected>{{(field.placeholder | translate) || ( 'Select %' | translate:
                                field.label
                                )}}
                            </option>
                            }
                            @for (option of field.field_options?.options; track option) {
                            <option [value]="option.value || option.label">{{option.label | translate}}</option>
                            }
                        </select>
                        }

                        }
                    </form-mui-field>
                    }
                </div>
                }
                }
                }
                <div class="m-t-5"
                     [gridColumn]="12">
                    @if(showCaptcha){
                    <button [status]="status"
                            class="w-12"
                            [buttonStyle]
                            [googleRecaptchaData]="captchaData"
                            [googleRecaptchaStatus]="status"
                            [googleRecaptcha]="captchaSubmit">{{(model.data?.submit_button_text || 'Submit') |
                        translate}}</button>
                    } @else {

                    <button [status]="status"
                            class="w-12"
                            [buttonStyle]
                            (click)="submit()">{{(model.data?.submit_button_text || 'Submit') | translate}}</button>
                    }
                    @if (status.error) {
                    <result [status]="status"
                            class="block m-t-1 _result"></result>
                    }
                </div>
            </div>
            }
            }

            @if(isSuccess){
            <div class="bg-col-52 b-a b-col-51 p-t-10 p-b-10 p-l-5 p-r-5 p-t-5-s p-b-5-s p-t-5-m p-b-5-m p-l-4-s p-l-4-m p-r-4-s p-r-4-m"
                 style="border-radius: 12px;">
                <h2 class="h1 h3-s h3-m col-1 m-b-2"
                    *iCms="'successTitle' of component; skipEmpty: true"></h2>
                <p class="p1 col-1 m-b-5"
                   *iCms="'successDescription' of component; skipEmpty: true"></p>
                @if(deliveryAddress?.length){
                <div class="m-b-5">
                    <p class="s1 col-1 m-b-1">{{'Delivery Address' | translate}}</p>
                    @for(part of deliveryAddress; track $index){
                    <p class="p1 col-11">{{part + ($last ? '' : ',')}}</p>
                    }
                </div>
                }
                <a [routerLink]="'/'"
                   class="inline-block w-12-s w-12-m"
                   [buttonStyle]="'button'">{{'continue shopping' | translate}}
                </a>
            </div>
            }

        </div>
        @if(!isSM){


        <div [gridColumn]="4"
             class="p-t-10">
            <div class="p-t-5"
                 [stickyPanel]="app.client.sizeId > 1">
                <div class="bg-col-51 p-a-5"
                     style="border-radius: 12px;">
                    <h4 class="h4 col-1 m-b-1"
                        *iCms="'yourSelectionTitle' of component; skipEmpty: true"></h4>
                    @if(isSelection){
                    <p class="p1 col-1"
                       *iCms="'yourSelectionDescription' of component; skipEmpty: true"></p>
                    }

                    <div [grid]="3"
                         class="m-t-6"
                         [gridColumnGap]="'20px'"
                         [gridRowGap]="'20px'">

                        @for(slot of slots; track slot) {
                        @if(isSelection || selectedProducts[slot]){
                        <div [gridColumn]="1">

                            <ng-container *ngTemplateOutlet="slotTemplate; context: { $implicit: slot }"></ng-container>
                        </div>
                        }
                        }
                    </div>
                    @if(!isSuccess){
                    <div class="m-t-5">
                        <button [buttonStyle]
                                (click)="selectionAction()"
                                [ngClass]="{'_is-disabled' : !submitAllowed}"
                                class="w-12">
                            {{ selectionCTATitle | translate }}
                        </button>
                    </div>
                    }
                </div>
            </div>
        </div>
        }
    </div>
    }
</form>
@if(display){


@if(isSM){
<div class="pos-fixed bottom-0 left-0 right-0 z-3 bg-col-52 b-a b-col-51 p-a"
     style="border-top-left-radius: 12px; border-top-right-radius: 12px;">
    <div class="flex flex-middle m-b">
        <h4 class="h4 col-1"
            *iCms="'yourSelectionTitle' of component; skipEmpty: true"></h4>
        @if(isSelection){
        <p class="p2 col-1 m-l-2"
           *iCms="'yourSelectionDescription' of component; skipEmpty: true"></p>
        }
    </div>

    <carousel class="default-swiper swiper-slide-per-view"
              style="overflow: visible;"
              [slidesPerView]="'auto'"
              [freeMode]="true"
              [style.--pc-slides-ceil]="pcSlidesCeil"
              [style.--pc-slides]="pcSlides"
              [style.--pc-gutter]="'8px'"
              imageViewRoot>
        @for(slot of slots; track slot) {

        @if(isSelection || selectedProducts[slot]){
        <ng-template carouselSlide>
            <ng-container *ngTemplateOutlet="slotTemplate; context: { $implicit: slot }"></ng-container>
        </ng-template>
        }
        }
    </carousel>
    @if(!isSuccess){

    <div class="m-t">
        <button [buttonStyle]
                (click)="selectionAction()"
                [ngClass]="{'_is-disabled' : !submitAllowed}"
                class="w-12">
            {{ selectionCTATitle | translate }}
        </button>
    </div>
    }
</div>
}
}


<ng-template #slotTemplate
             let-slot>

    @if(selectedProducts[slot]){
    <span class="flex-column w-12">
        <div style="border-radius: 12px;"
             class="overflow-hidden pos-relative">
            <div class="fill b-a b-col-6 b-w-2"
                 style="border-radius: 12px;">

            </div>
            <img class="w-12"
                 [dfImage]="selectedProducts[slot].data?.image"
                 [alt]="selectedProducts[slot].data?.name || ''"
                 [ratio]="1">
            @if(isSelection){
            <button type="button"
                    (click)="removeProduct(selectedProducts[slot])"
                    class="bg-col-w flex flex-justify-center flex-middle pos-absolute"
                    style="height: 20px; width: 20px; border-radius: 100%; top: 7px; right: 7px;">
                <i class="icon-close flex"
                   style="font-size: 17px;"></i>
            </button>
            }
        </div>
        <span class="m-t-1 w-12 center p2"
              style="white-space: normal;">
            {{selectedProducts[slot].data?.name}}
        </span>
    </span>
    } @else {
    <div class="ratio-1-1 b-a b-col-4"
         style="border-style: dashed; border-radius: 12px;">
        <div class="fill flex flex-justify-center flex-middle">
            <div class="bg-col-w flex flex-justify-center flex-middle"
                 style="border-radius: 100%; height: 24px; width: 24px;">
                <i class="icon-plus flex"
                   style="font-size: 20px;"></i>
            </div>
        </div>
    </div>
    <div class="center m-t-1">
        <p class="p2 col-1">{{'Add Swatch' | translate}}</p>
    </div>
    }
</ng-template>